'use client';
import './product-detail.scss';
import { ProductEnergyValuesT } from './types';

type Props = {
    energyValues?: ProductEnergyValuesT;
};
export const ProductDetailInfoEnergyValuesTable = ({ energyValues }: Props) => {
    if (!energyValues) {
        return null;
    }

    return (
        <table data-testid="product-detail-energy-values-table">
            <tbody>
                <tr className="product-detail__info-energy-values-row">
                    <th align="left">Energetická hodnota na 100 g</th>
                    <td
                        align="right"
                        data-testid="product-detail-energy-values"
                        data-value={`${energyValues.energyKJ},${energyValues.calories}`}
                    >
                        {energyValues.energyKJ} kJ ({energyValues.calories} kcal)
                    </td>
                </tr>
            </tbody>
        </table>
    );
};
